<template>
  <TranscriptPreview
    v-if="currentTranscript"
    ref="transcriptPreview"
    class="episode-transcript-preview hidden"
    :theme="theme"
    :transcript="currentTranscript"
  />
</template>

<script>
import TranscriptPreview from '../admin/transcripts/components/TranscriptPreview'
import { THEMES } from '../shared/utils/view_options'
import TranscriptsApiService from '../admin/transcripts/services/transcriptsApi.service'

export default {
  name: 'MobileEpisodeTranscriptAppComponent',
  components: {
    TranscriptPreview,
  },
  data() {
    return {
      theme: THEMES.DARK,
      publicTranscripts: [],
      currentTranscript: null,
      loading: true,
    }
  },
  mounted() {
    this.fetchPublicTranscripts()
  },
  methods: {
    toggleTranscript(elementId) {
      this.$el.classList.toggle('hidden')
      document.getElementById(elementId).classList.toggle('active')
      document.getElementById('suggestedEpisodesContainer').classList.toggle('hidden')
      document.getElementById('nextEpisodeContainer').classList.toggle('hidden')
    },
    fetchPublicTranscripts() {
      this.loading = true

      TranscriptsApiService.getPublicTranscripts(this.optional_params)
        .then((response) => {
          const responseData = response.data

          this.publicTranscripts = responseData.transcripts
          this.currentTranscript = this.publicTranscripts[0]

          if (this.publicTranscripts.length > 0) {
            const mobileButtonIds = [
              'toggleTranscriptButtonMobile',
              'toggleTranscriptButtonTablet',
            ]

            mobileButtonIds.forEach((elementId) => {
              const toggleTranscriptButton = document.getElementById(elementId)

              if (toggleTranscriptButton) {
                toggleTranscriptButton.classList.toggle('hidden')
                toggleTranscriptButton.addEventListener('click', () => {
                  this.toggleTranscript(elementId)
                })
              }
            })
          }
        })
        .finally(() => (this.loading = false))
    },
  },
}
</script>

<style lang="scss">
.episode-transcript-preview {
  display: block;

  &.hidden {
    display: none;
  }
}
</style>
